import { NotificationFields } from './notificationFields';

export class NotificationFilter {

    public name: string;
    public description: string;
    public notificationChannels: string[] = ['Email', 'Stream'];
    public modules: string[];
    public notificationGroups: string[] = [];
    public notificationTypes: string[] = [];
    public page: number = 1;
    public pageSize: number = 10;
    public sortByField: NotificationFields;

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/app/tools/notificationEditor/notificationFilter.ts